import { Link, useNavigate, useParams, useLocation } from 'react-router-dom';
import apiMethod from '../../../services/api-service';
import methods from '../../../services/utility';
import { useState, useEffect, useRef } from 'react';
//import * as htmlToImage from 'html-to-image';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";
import searchCustomer from "../../../assets/images/icons/searchCustomer.svg";
import CardView from "../../../assets/images/icons/CardView.svg";
import CardViewActive from "../../../assets/images/icons/cardViewActive.svg";
import ImgView from "../../../assets/images/icons/ImgView.svg";
import ImgViewActive from "../../../assets/images/icons/ImgViewActive.svg";
import Preloading from '../../../components/basics/Preloading';
import Notification from '../../../components/notification/Notification';
//import OrderDeleteButton from '../../../components/Buttons/OrderDeleteButton';
import pushDataImg from '../../../assets/images/img/pushDataImg.svg'

import * as signalR from '@microsoft/signalr';
import OrderPushData from '../../../components/notification/OrderPushData';
import SnappPushData from '../../../components/notification/SnappPushData';
import Paginations from '../../../components/paginaton/Paginations';

const WaiterOrdering = () => {
  const { branchId, cashDeskId } = useParams();
  const navigate = useNavigate();
  const orderingInfo = methods.getOrderingStatics();
  const [localService, setLocalService] = useState({
    baseUrl: ""
  });
  const [filterObj, setFilterObj] = useState({
    branchId: branchId,
    cashDeskId: cashDeskId,
    unitId: orderingInfo.saleUnitId,
    categoryId: 0,
    orderType: 1,
    menuTitle: "",
    size: 30,
    part: 1,
    total: 0,
    parts: 0
  });
  const [units, setUnits] = useState([]);
  const [orderTypes, setOrderTypes] = useState([]);
  const [menuCategories, setMenuCategories] = useState([]);
  const [saleMenus, setSaleMenus] = useState([]);
  const [posDevices, setPosDevices] = useState([]);
  const [diningTables, setDiningTables] = useState([]);
  const [pagers, setPagers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isCardView, setCardView] = useState(true);
  const [shipments, setShipments] = useState([]);
  const [correctionModel, setCorrectionModel] = useState({
    invoiceNumber: "",
    description: "",
    items: []
  });
  const [showcreateMerchantModal, setShowCreateMerchantModal] = useState(false);
  const [showsearchMerchantModal, setShowSearchMerchantModal] = useState(false);
  const [merchantFilter, setMerchantFilter] = useState({
    branchId: branchId,
    name: "",
    code: "",
    mobile: "",
    size: 20,
    part: 1,
    total: 0,
    parts: 0
  });
  const [merchantList, setMerchantList] = useState([]);
  const [merchant, setMerchant] = useState({
    id: 0,
    merchantType: 1,
    firstName: "",
    lastName: "",
    genderType: 1,
    identityNumber: "",
    nationalNumber: "",
    mobile: "",
    phone: "",
    email: "",
    companyName: "",
    nikCompanyName: "",
    economicCode: "",
    registrationNumber: "",
    webSiteAddress: "",
    faxNumber: "",
    creditable: true,
    branchId: branchId
  });
  const [userAddresses, setUserAddresses] = useState([]);
  const addressModel = {
    id: 0,
    title: "",
    address: "",
    phone: "",
    zipCode: "",
    faxNumber: "",
    cityId: null,
    userId: 0
  };
  const [order, setOrder] = useState({
    id: 0,
    invoiceNumber: "",
    orderNumber: 1,
    merchantName: " ",
    merchantCode: "",
    merchantPhone: "",
    destination: "",
    orderType: 1,
    paymentType: 0,
    orderStatus: 0,
    isPaid: false,
    description: "",
    orderDescription: "",
    packingPrice: 0,
    servePrice: 0,
    cashDeskId: cashDeskId,
    saleUnitId: orderingInfo.saleUnitId,
    merchantId: null,
    deliveryId: null,
    posDeviceId: null,
    diningTableId: null,
    pagerDeviceId: null,
    branchId: branchId,
    createDate: "",
    userId: "",
    shipmentId: null,
  });
  const [orderItems, setOrderItems] = useState([]);
  const [totalNumbers, setTotalNumbers] = useState({
    totalFreeTaxPrice: 0,
    totalTax: 0,
    totalDiscount: 0,
    totalFinalPrice: 0,
    services: [],
  });
  const [orderingSettings, setOrderingSettings] = useState({
    useServicePackingPrice: false,
    servicePackingPrice: 0,
    finalPackingPrice: 0,
    totalMenusPackingPrice: 0,
  });
  const [currentOrders, setCurrentOrders] = useState([]);
  const [currentOrderModalShow, setCurrentOrderModalShow] = useState(false);
  const [paymentModalShow, setPaymentModalShow] = useState(false);
  const [printKitchenModalShow, setPrintKitchenModalShow] = useState(false);
  const [printers, setPrinters] = useState([]);
  const [localPrinters, setlocalPrinters] = useState([]);
  const [invoicePirntInfo, setInvoicePirntInfo] = useState({
    footer1: '',
    footer2: '',
    footer3: ''
  });
  const [paymentModel, setPaymentModel] = useState({
    paymentType: 0,
    posDeviceId: 0,
    invoiceId: 0,
    tipAmount: 0,
    amount: 0,
    cashAmount: 0,
    posAmount: 0,
    cardNumber: ""
  });
  let orderItem = {
    id: 0,
    saleMenuId: 0,
    amount: 1,
    description: "",
    packingPrice: 0,
    invoiceId: 0
  };
  const [merchantPreviousOrdersFilter, setMerchantPreviousOrdersFilter] = useState({
    branchId: branchId,
    userId: "",
    size: 3,
    part: 1,
    repCount: 3
  });
  const [showMerchantPreviousOrdersModal, setShowMerchantPreviousOrdersModal] = useState(false);
  const [merchantPreviousOrders, setMerchantPreviousOrders] = useState({});
  const [merchantPreviousOrdersInfo, setMerchantPreviousOrdersInfo] = useState({});
  const [merchantPreviousOrdersData, setMerchantPreviousOrdersData] = useState([]);
  const [merchantPreviousOrdersRepetitives, setMerchantPreviousOrdersRepetitives] = useState([]);
  const [paymentWaiting, setpaymentWaiting] = useState(false);
  const [selectedPrinter, setSelectedPrinter] = useState({
    kitchenPrinterDevice: null,
    orderingPrinterDevice: null
  });
  const scrollRef = useRef(null);
  const [callers, setCallers] = useState([]);
  const [showCallerIdModal, setShowCallerIdModal] = useState(false);
  const [snappOrders, setSnappOrders] = useState([]);
  const [showSnappCallerModal, setShowSnappCallerIdModal] = useState(false);
  const [showSnappToast, setShowSnappToast] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [cardDisabled, setCardDisabled] = useState(false);

  const [printModel, setPrintModel] = useState({
    kitchenPrintModel: null,
    orderPrintModel: null,
    printers: []
  });

  const addCaller = (caller) => {
    setCallers(prevCallers => [...prevCallers, caller]);
  };

  const resetCallers = () => {
    setCallers([]);
  };

  const removeCaller = (callerToRemove) => {
    setCallers(prevCallers => prevCallers.filter(caller => caller !== callerToRemove));
  };

  const addSnappCaller = (caller) => {
    setSnappOrders(prevCallers => [...prevCallers, caller]);
    setShowSnappToast(true);
  };

  const resetSnappCallers = () => {
    setSnappOrders([]);
  };

  const URL = process.env.REACT_APP_ROOT_MSG + "/DataHub/?connectionId=" + branchId;
  const createConnection = async () => {
    let conn = new signalR.HubConnectionBuilder()
      .withUrl(URL)
      .withAutomaticReconnect()
      .build();
    await conn.start().catch(err => console.log(err)).then(() => {
      conn.invoke('GetConnectionId').then(function (connectionId) {
        console.log('connectionId: ' + connectionId);
      });
    });
    conn.on("ReceiveCallerNumber", (bid, merchantInfo) => {
      addCaller(merchantInfo);
    });
    conn.on("ReceiveSnappOrder", (bid, orderData) => {
      addSnappCaller(orderData);
    });
  };

  const addCorrectionToList = () => {
    if (correctionModel.invoiceNumber.trim() !== '' && correctionModel.description.trim() !== '') {
      correctionModel.items.push({
        invoiceNumber: correctionModel.invoiceNumber,
        description: correctionModel.description
      });
      setCorrectionModel({ ...correctionModel, invoiceNumber: '', description: '' });
    }
  };

  const removeFormCorrectionLis = (index) => {
    correctionModel.items.splice(index, 1);
    setCorrectionModel({ ...correctionModel });
  };

  const mapMerchant = (model) => {
    merchant.id = model.id;
    merchant.merchantType = model.merchantType;
    merchant.firstName = model.firstName;
    merchant.lastName = model.lastName;
    merchant.genderType = model.genderType;
    merchant.identityNumber = model.identityNumber;
    merchant.nationalNumber = model.nationalNumber;
    merchant.mobile = methods.formatPhoneNumber(model.mobile);
    merchant.phone = model.phone;
    merchant.email = model.email;
    merchant.companyName = model.companyName;
    merchant.nikCompanyName = model.nikCompanyName;
    merchant.economicCode = model.economicCode;
    merchant.registrationNumber = model.registrationNumber;
    merchant.webSiteAddress = model.webSiteAddress;
    merchant.faxNumber = model.faxNumber;
    setMerchant({ ...merchant });
  };

  const mapSetting = (model) => {
    const invoiceSettings = JSON.parse(model.settingItems);
    let slogan = invoiceSettings.find(x => x.KeyName === 'Slogan');
    let tels = invoiceSettings.find(x => x.KeyName === 'Tels');
    let address = invoiceSettings.find(x => x.KeyName === 'Address');

    if (slogan) invoicePirntInfo.footer1 = slogan.SettingValue;
    if (tels) invoicePirntInfo.footer2 = tels.SettingValue;
    if (address) invoicePirntInfo.footer3 = address.SettingValue;
    setInvoicePirntInfo(invoicePirntInfo);
  };

  const getPrinterSettings = async () => {
    const resp = await apiMethod.getSettingByName(branchId, "LocalServices");
    if (!methods.showApiErrors(resp))
      return false;

    let settings = JSON.parse(resp.data.settingItems);
    let setting = await settings.find(x => x.KeyName === 'HostPath');
    localService.baseUrl = setting.SettingValue;
    setLocalService({ ...localService });
  }

  const getLocalPrinters = async () => {
    try {
      const localPrintersResp = await apiMethod.getLocalPrinters(localService.baseUrl);
      if (!methods.showApiErrors(localPrintersResp)) {
        throw new Error('Error fetching local printers');
      }
      setlocalPrinters(localPrintersResp.data);
    } catch (error) {
      methods.showErrors(['خطا در اتصال پرینتر ']);
      console.log(error);
    }
  }

  const bindBaseData = async () => {
    await getPrinterSettings();
    const baseInfoResp = await apiMethod.getOrderingBaseInfo(branchId);
    if (methods.showApiErrors(baseInfoResp)) {
      setUnits(baseInfoResp.data.saleUnits);
      setOrderTypes(baseInfoResp.data.orderTypes);
      setPagers(baseInfoResp.data.pagerDevices);
      setDiningTables(baseInfoResp.data.diningTables);
      setShipments(baseInfoResp.data.shipments);
      orderingSettings.useServicePackingPrice = baseInfoResp.data.useDefaultPackingPrice;
      orderingSettings.servicePackingPrice = baseInfoResp.data.servicePackingPrice;
      if (orderingSettings.useServicePackingPrice)
        orderingSettings.finalPackingPrice = orderingSettings.servicePackingPrice;
      setOrderingSettings({ ...orderingSettings });
      if (filterObj.unitId > 0)
        getMenuCategories();
    }

    await getLocalPrinters();

    const printerResp = await apiMethod.getPrinters(branchId, "", 50, 1);
    if (methods.showApiErrors(printerResp))
      setPrinters(printerResp.data);

    const settingResp = await apiMethod.getSettingByName(branchId, "Invoice");
    if (methods.showApiErrors(settingResp))
      mapSetting(settingResp.data);

    if (filterObj.cashDeskId > 0)
      getOpenOrders();
  };

  const saleUnitchanged = async (unitId) => {
    filterObj.unitId = parseInt(unitId);
    filterObj.part = 1;
    if (filterObj.unitId === 0) {
      setMenuCategories([]);
      setSaleMenus([]);
      return;
    }
    filterObj.categoryId = 0;
    setFilterObj({ ...filterObj, unitId: filterObj.unitId });
    methods.setOrderingStatics(filterObj.unitId, filterObj.cashDeskId);
    order.saleUnitId = filterObj.unitId;
    setOrder({ ...order, saleUnitId: filterObj.unitId });
    setLoading(true);
    await getMenuCategories();
    await bindMenus();
    setLoading(false);
  };

  const getMenuCategories = async () => {
    const response = await apiMethod.getMenuCategoriesOrders(branchId, filterObj.unitId);
    if (!methods.showApiErrors(response))
      return false;
    setMenuCategories(response.data);
  }

  const onCategoryClick = async (categoryId) => {
    filterObj.categoryId = parseInt(categoryId);
    filterObj.part = 1;
    setFilterObj({ ...filterObj, categoryId: filterObj.categoryId });
    if (filterObj.unitId === 0) {
      setMenuCategories([]);
      setSaleMenus([]);
      return;
    }
    setLoading(true);
    const resp = await apiMethod.getOrderSaleMenus(filterObj.branchId, filterObj.unitId, filterObj.categoryId, filterObj.size, filterObj.part, filterObj.menuTitle);
    setLoading(false);
    // if (methods.showApiErrors(resp)) setSaleMenus(resp.data);
    if (methods.showApiErrors(resp)) {
      filterObj.total = resp.total;
      filterObj.parts = methods.calcPageParts(resp.total, filterObj.size);
      setFilterObj({ ...filterObj });
      setSaleMenus(resp.data);
    }
  };

  const shipmentIdChanged = (e) => {
    const selectedId = parseInt(e.target.value);
    order.shipmentId = selectedId === 0 ? null : selectedId;
    setOrder({ ...order });
  };

  const getPosData = async () => {
    const posResp = await apiMethod.getOrderDeskPosDevices(cashDeskId);
    if (methods.showApiErrors(posResp)) {
      setPosDevices(posResp.data);
    }
  };

  const bindMenus = async () => {
    setLoading(true);
    if (filterObj.unitId !== 0) {
      const resp = await apiMethod.getOrderSaleMenus(filterObj.branchId, filterObj.unitId, filterObj.categoryId, filterObj.size, filterObj.part, filterObj.menuTitle);
      setLoading(false);
      if (methods.showApiErrors(resp)) {
        filterObj.total = resp.total;
        filterObj.parts = methods.calcPageParts(resp.total, filterObj.size);
        setFilterObj({ ...filterObj });
        setSaleMenus(resp.data);
      }
    }
    setLoading(false);
  };

  const findMenus = async (title) => {
    filterObj.menuTitle = title;
    setFilterObj({ ...filterObj, menuTitle: title });
    bindMenus();
  };

  const changedMerchantName = (name) => {
    merchantFilter.name = name;
    setMerchantFilter({ ...merchantFilter, name: name });
    order.merchantName = name;
    setOrder({ ...order, merchantName: name });
  };

  const changedMerchantMobile = (mobile) => {
    merchantFilter.mobile = mobile;
    setMerchantFilter({ ...merchantFilter });
    order.merchantPhone = mobile;
    setOrder({ ...order });
  };

  const changedMerchantCode = (code) => {
    merchantFilter.code = code;
    setMerchantFilter({ ...merchantFilter, code: code });
    order.merchantCode = code;
    setOrder({ ...order, merchantCode: code });
  };

  const showMerchants = async () => {
    setLoading(true);
    const resp = await apiMethod.findOrdersMerchants(branchId, merchantFilter.size, merchantFilter.part, merchantFilter.mobile, merchantFilter.code, merchantFilter.name);
    setLoading(false);
    if (methods.showApiErrors(resp)) {
      merchantFilter.total = resp.total;
      merchantFilter.parts = methods.calcPageParts(resp.total, merchantFilter.size);
      setMerchantList(resp.data);
      setShowSearchMerchantModal(true);
    }
  };

  const getBulkOrderInfo = async (invoiceId) => {
    if (invoiceId !== 0) {
      const resp = await apiMethod.getBulkOrderInfo(invoiceId);
      if (methods.showApiErrors(resp)) {
        syncOrderData(resp.data.invoice);
        filterObj.cashDeskId = order.cashDeskId;
        filterObj.unitId = order.saleUnitId;
        setFilterObj({ ...filterObj });
        setOrderItems(resp.data.invoiceItems);
        setTotalNumbers(resp.data.totalNumbers);
        orderingSettings.totalMenusPackingPrice = resp.data.totalMenusPackingPrice;
        setOrderingSettings({ ...orderingSettings });
      }
    }
  };

  const addAddressField = () => {
    userAddresses.push(addressModel);
    setUserAddresses([...userAddresses]);
  };

  const addressTitleChange = (index, title) => {
    userAddresses[index].title = title;
    setUserAddresses([...userAddresses]);
  };

  const addressTextChange = (index, text) => {
    userAddresses[index].address = text;
    setUserAddresses([...userAddresses]);
  };

  const isValidMerchant = () => {
    let errors = [];

    if (!merchant.merchantType) {
      errors.push("نوع مشتری باید مقدار داشته باشد.");
    }

    if (merchant.merchantType === 1) {
      if (methods.isNullOrEmptyString(merchant.firstName)) {
        errors.push("نام مشتری باید مقدار داشته باشد.");
      }
      if (methods.isNullOrEmptyString(merchant.lastName)) {
        errors.push("نام خانوادگی مشتری باید مقدار داشته باشد.");
      }
      if (methods.isNullOrEmptyString(merchant.mobile)) {
        errors.push("موبایل مشتری باید مقدار داشته باشد.");
      }
    } else if (merchant.merchantType === 2) {
      if (methods.isNullOrEmptyString(merchant.firstName)) {
        errors.push("نام شرکت باید مقدار داشته باشد.");
      }
      if (methods.isNullOrEmptyString(merchant.companyName)) {
        errors.push("نام اختصاصی شرکت باید مقدار داشته باشد.");
      }
      if (methods.isNullOrEmptyString(merchant.mobile)) {
        errors.push("موبایل مشتری باید مقدار داشته باشد.");
      }
    }

    userAddresses.forEach((item) => {
      if (methods.isNullOrEmptyString(item.title)) {
        errors.push("عنوان آدرس باید مقدار داشته باشد.");
      }
      if (methods.isNullOrEmptyString(item.address)) {
        errors.push("آدرس باید مقدار داشته باشد.");
      }
    });

    if (errors.length > 0) {
      methods.showErrors(errors);
      return false;
    }

    return true;
  };

  const createMerchant = async () => {
    if (!isValidMerchant())
      return false;

    setLoading(true);

    const apiResp = await apiMethod.createMerchantWithAddress({
      Merchant: merchant,
      UserAddresses: userAddresses
    });

    if (!methods.showApiErrors(apiResp))
      return false;

    mapMerchant(apiResp.data.merchant);
    // selectMerchant(apiResp.data.merchant, apiResp.data.userAddresses);
    selectMerchant(apiResp.data.merchant, apiResp.data.userAddresses, apiResp.data.merchant.userId);
    setShowCreateMerchantModal(false);
    setLoading(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        await bindBaseData();
        await bindMenus();
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
    createConnection();

    if (filterObj.cashDeskId > 0 && cashDeskId === "0") {
      const newUrl = `/sale/${branchId}/submitOrder/${filterObj.cashDeskId}`;
      navigate(newUrl);
    }
  }, [branchId]);

  const selectMerchant = (merModel, addresses, userId) => {
    mapMerchant(merModel);
    order.userId = userId;
    order.merchantId = merModel.id;
    order.merchantCode = merModel.merchantCode;
    order.merchantName = merModel.firstName + " " + merModel.lastName;
    order.merchantPhone = methods.formatPhoneNumber(merModel.mobile);
    if (addresses != null && addresses != undefined && addresses.length > 0)
      order.destination = addresses[0].address;
    setOrder({ ...order });
    resetMerchant();
    setShowSearchMerchantModal(false);
  };

  const resetOrderItem = () => {
    orderItem = {
      id: 0,
      saleMenuId: 0,
      amount: 1,
      description: "",
      invoiceId: 0
    };
  };

  const resetOrder = () => {
    order.id = 0;
    order.invoiceNumber = "";
    order.orderNumber = 1;
    order.merchantName = "";
    order.merchantCode = "";
    order.merchantPhone = "";
    order.destination = "";
    order.orderType = 1;
    order.paymentType = 0;
    order.orderStatus = 0;
    order.isPaid = false;
    order.description = "";
    order.orderDescription = "";
    order.packingPrice = 0;
    order.servePrice = 0;
    order.cashDeskId = cashDeskId;
    //order.saleUnitId = "";
    order.merchantId = null;
    order.deliveryId = null;
    order.posDeviceId = null;
    order.diningTableId = null;
    order.pagerDeviceId = null;
    order.branchId = branchId;
    order.createDate = "";
    order.userId = "";
    order.shipmentId = null;
    setOrder({ ...order });
    resetOrderItem();
    setOrderItems([]);
    // orderItems.splice(0, orderItems.length);
    // setOrderItems([...orderItems]);
    totalNumbers.totalFreeTaxPrice = 0;
    totalNumbers.totalTax = 0;
    totalNumbers.totalDiscount = 0;
    totalNumbers.totalFinalPrice = 0;
    totalNumbers.services = [];
    setTotalNumbers({ ...totalNumbers });
    if (orderingSettings.useServicePackingPrice)
      orderingSettings.finalPackingPrice = orderingSettings.servicePackingPrice;
    else
      orderingSettings.finalPackingPrice = 0;

    orderingSettings.totalMenusPackingPrice = 0;
    setOrderingSettings({ ...orderingSettings });
  };

  const resetMerchant = () => {
    merchant.id = 0;
    merchant.merchantType = 1;
    merchant.firstName = "";
    merchant.lastName = "";
    merchant.genderType = 1;
    merchant.identityNumber = "";
    merchant.nationalNumber = "";
    merchant.mobile = "";
    merchant.phone = "";
    merchant.email = "";
    merchant.companyName = "";
    merchant.nikCompanyName = "";
    merchant.economicCode = "";
    merchant.registrationNumber = "";
    merchant.webSiteAddress = "";
    merchant.faxNumber = "";
    setMerchant({ ...merchant });
    userAddresses.splice(0, userAddresses.length);
    setUserAddresses([]);
  };

  const resetCorrectionModel = () => {
    correctionModel.invoiceNumber = "";
    correctionModel.description = "";
    correctionModel.items = [];
    setCorrectionModel({ ...correctionModel });
  };

  const resetTotalNumber = () => {
    totalNumbers.totalFreeTaxPrice = 0;
    totalNumbers.totalTax = 0;
    totalNumbers.totalDiscount = 0;
    totalNumbers.totalFinalPrice = 0;
    totalNumbers.services = [];
    setTotalNumbers({ ...totalNumbers });
  }

  const isValidOrder = () => {
    let errors = [];
    if (order.branchId < 1)
      errors.push("شناسه شعبه باید مقدار داشته باشد.");
    if (order.saleUnitId < 1)
      errors.push("لطفا ابتدا بخش فروش مورد نظر خود را انتخاب کنید.");
    if (order.cashDeskId < 1)
      errors.push("لطفا ابتدا صندوق مورد نظر خود را انتخاب کنید.");
    if (order.orderType < 1)
      errors.push("لطفا ابتدا نوع سفارش مورد نظر خود را انتخاب کنید.");

    if (errors.length > 0) {
      methods.showErrors(errors);
      return false;
    }

    return true;
  };

  const isValidOrderItem = () => {
    let errors = [];
    if (orderItem.saleMenuId <= 0 && orderItem.id <= 0) {
      errors.push("شناسه منو یا آیتم انتخابی باید انتخاب شده باشد");
    }
    if (!orderItem.amount || orderItem.amount <= 0) {
      errors.push("تعداد سفارش باید مقدار داشته باشد.");
    }
    if (orderItem.id > 0 && (!orderItem.invoiceId || orderItem.invoiceId <= 0)) {
      errors.push("شناسه سفارش باید مقدار داشته باشد.");
    }

    if (errors.length > 0) {
      methods.showErrors(errors);
      return false;
    }

    return true;
  };

  const syncOrderData = (model) => {
    order.id = model.id;
    order.invoiceNumber = model.invoiceNumber;
    order.orderNumber = model.orderNumber;
    order.merchantName = model.merchantName;
    order.merchantCode = model.merchantCode;
    order.merchantPhone = methods.formatPhoneNumber(model.merchantPhone);
    order.destination = model.destination;
    order.orderType = model.orderType;
    order.paymentType = model.paymentType;
    order.orderStatus = model.orderStatus;
    order.isPaid = model.isPaid;
    order.description = model.description;
    order.orderDescription = model.orderDescription;
    //order.packingPrice = model.packingPrice;
    order.cashDeskId = model.cashDeskId;
    order.saleUnitId = model.saleUnitId;
    order.merchantId = model.merchantId;
    order.deliveryId = model.deliveryId;
    order.posDeviceId = model.posDeviceId;
    order.diningTableId = model.diningTableId;
    order.pagerDeviceId = model.pagerDeviceId;
    order.shipmentId = model.shipmentId;
    order.branchId = branchId;
    order.createDate = model.createDate;
    setOrder(order);
  };

  const createOrder = async () => {
    order.cashDeskId = filterObj.cashDeskId;
    if (!isValidOrder()) return false;

    order.packingPrice = orderingSettings.finalPackingPrice;
    const orderResp = await apiMethod.createOrder(order);
    if (!methods.showApiErrors(orderResp)) return false;

    syncOrderData(orderResp.data);
    return true;
  };

  const saveOrder = async () => {
    setLoading(true);
    if (!await createOrder())
      methods.showErrors(["ذخیره اطلاعات سفارش با مشکلی مواجه شده است."]);
    await getBulkOrderInfo(order.id);
    setLoading(false);
  };

  const changeCountOfMenu = (menuId, countUp) => {
    if (menuId > 1) {
      let index = saleMenus.findIndex(p => p.id === menuId);
      if (index !== -1) {
        let currentValue = saleMenus[index];
        if (countUp) {
          saleMenus[index].orderItemCount += 1;
        } else if (currentValue.orderItemCount > 0) {
          saleMenus[index].orderItemCount -= 1;
        }
      } else {
        return false;
      }
    }
  };

  const addOrderItem = async (itemId, menuId, amount, menuPackingPrice) => {
    if (disabled && cardDisabled) return;
    setDisabled(true);
    setCardDisabled(true);

    addMenuPackingPrice(menuPackingPrice);

    if (!await createOrder()) {
      setDisabled(false);
      setCardDisabled(false);
      return false;
    }

    resetOrderItem();

    if (itemId > 0) orderItem.id = itemId;
    if (menuId > 0) orderItem.saleMenuId = menuId;
    orderItem.invoiceId = order.id;
    orderItem.amount = amount;
    orderItem.packingPrice = orderingSettings.finalPackingPrice;

    if (!isValidOrderItem()) {
      setDisabled(false);
      setCardDisabled(false);
      return false;
    }

    const orderItemResp = await apiMethod.addMenuToOrderItem(orderItem);
    if (!methods.showApiErrors(orderItemResp)) {
      setDisabled(false);
      setCardDisabled(false);
      return false;
    }

    await getBulkOrderInfo(order.id);
    changeCountOfMenu(menuId, true);
    setDisabled(false);
    setCardDisabled(false);
  };

  const addMenuPackingPrice = (menuPackingPrice) => {
    if (!orderingSettings.useServicePackingPrice) {
      orderingSettings.finalPackingPrice = orderingSettings.totalMenusPackingPrice + menuPackingPrice;
    }
    setOrderingSettings({ ...orderingSettings });
  };

  const removeMenuPackingPrice = (menuPackingPrice) => {
    if (!orderingSettings.useServicePackingPrice) {
      orderingSettings.finalPackingPrice = orderingSettings.totalMenusPackingPrice - menuPackingPrice;
    }
    setOrderingSettings({ ...orderingSettings });
  };

  const removeOrderItem = async (itemId, menuId, amount, menuPackingPrice) => {
    if (disabled) return;
    setDisabled(true);

    removeMenuPackingPrice(menuPackingPrice);
    resetOrderItem();

    if (itemId > 0) orderItem.id = itemId;
    if (menuId > 0) {
      orderItem.saleMenuId = menuId;
      orderItem.invoiceId = order.id;
      orderItem.amount = amount;
      orderItem.packingPrice = orderingSettings.finalPackingPrice;
    }

    if (!isValidOrderItem()) {
      setDisabled(false);
      return false;
    }

    const apiResp = await apiMethod.removeMenuFromOrderItem(orderItem);
    if (!methods.showApiErrors(apiResp)) {
      setDisabled(false);
      return false;
    }

    await getBulkOrderInfo(order.id);
    changeCountOfMenu(menuId, false);
    setDisabled(false);
  };

  const removeOrder = async (invoiceId) => {
    if (invoiceId < 1) {
      methods.showErrors(["حداقل یک آیتم برای حذف باید انتخاب شود."]);
      return false;
    }
    const apiResp = await apiMethod.removeOrder(invoiceId);
    if (!methods.showApiErrors(apiResp)) {
      return false;
    }
    return true;
  };

  const removeOrderFromForm = async (invoiceId) => {
    setLoading(true);
    if (!await removeOrder(invoiceId)) {
      setLoading(false);
      return false;
    }
    bindMenus();
    resetOrder();
    setLoading(false);
  };

  const removeOrderFromCurrentLis = async (invoiceId) => {
    setLoading(true);
    if (!await removeOrder(invoiceId)) {
      setLoading(false);
      return false;
    }
    await getOpenOrders();
    setLoading(false);
  };

  const editOrder = async (invoiceId) => {
    if (invoiceId < 1) {
      methods.showErrors(["حداقل یک آیتم برای ویرایش باید انتخاب شود."]);
      return false;
    }
    setLoading(true);
    await getBulkOrderInfo(invoiceId);
    setCurrentOrderModalShow(false);
    setLoading(false);
    const newUrl = `/sale/${branchId}/submitOrder/${cashDeskId}`;
    navigate(newUrl);
    await bindMenus();
  };

  const sendToKitchen = async () => {
    if (order.id < 1) {
      methods.showErrors(["ابتدا باید یک سفارش برای ارسال ایجاد کنید."]);
      return false;
    }
    setLoading(true);
    await apiMethod.sendOrderToKitchen(order.id);
    resetOrder();
    closePaymentModal();
    setLoading(false);
  };

  const getOpenOrders = async () => {
    if (filterObj.cashDeskId === 0) {
      setCurrentOrders([]);
      return true;
    }

    const apiRes = await apiMethod.getCurrentOrders(branchId, filterObj.cashDeskId, 100, 1, "");
    if (!methods.showApiErrors(apiRes)) return false;
    setCurrentOrders(apiRes.data);
    return true;
  };

  const openCurrentOrderModal = async () => {
    if (filterObj.cashDeskId === 0) {
      setCurrentOrders([]);
      setCurrentOrderModalShow(true);
      return;
    }

    setLoading(true);
    var isOk = await getOpenOrders();
    setLoading(false);
    if (!isOk) return false;
    setCurrentOrderModalShow(true);
  };

  const validPrinters = (printerUnitType) => {
    if (printModel.printers.length === 0) {
      methods.showErrors(["خطا در تنظیمات پرینتر. هیچ دستگاهی در نرم افزار تعریف نشده است."]);
      return false;
    }

    if (printerUnitType === 1) {
      if (methods.isNullOrEmptyString(printModel.orderPrintModel.printerName)) {
        methods.showErrors(["خطا در تنظیمات پرینتر. هیچ دستگاهی برای آشپزخانه تعریف نشده است."]);
        return false;
      } else if (!localPrinters.includes(printModel.orderPrintModel.printerName)) {
        methods.showErrors(["خطا در اتصالات دستگاه پرینتر " + printModel.orderPrintModel.printerName + " به کامپیوتر شما."]);
        return false;
      }
    }

    if (printerUnitType === 2) {
      if (methods.isNullOrEmptyString(printModel.kitchenPrintModel.printerName)) {
        methods.showErrors(["خطا در تنظیمات پرینتر. هیچ دستگاهی برای صندوق تعریف نشده است."]);
        return false;
      } else if (!localPrinters.includes(printModel.kitchenPrintModel.printerName)) {
        methods.showErrors(["خطا در اتصالات دستگاه پرینتر " + printModel.kitchenPrintModel.printerName + " به کامپیوتر شما."]);
        return false;
      }
    }

    return true;
  };

  const [imageSrc, setImageSrc] = useState("");

  const printKitchenCorrection = async () => {
    if (!validPrinters(2))
      return false;

    if (correctionModel.items.length === 0) {
      methods.showErrors(["هیچ آیتمی جهت ارسال چاپ ثبت نشده است"]);
      return false;
    }

    const apiRes = await apiMethod.kitchenCorrectionPrint(localService.baseUrl, {
      printerName: selectedPrinter.kitchenPrinterDevice.name,
      title: "اصلاحات آشپزخانه",
      rightTitle: "شماره فاکتور",
      leftTile: "توضیحات",
      items: correctionModel.items
    });
    if (!methods.showApiErrors(apiRes))
      return false;

    correctionModel.invoiceNumber = "";
    correctionModel.description = "";
    correctionModel.items = [];
    setCorrectionModel({ ...correctionModel });
  };

  const setPrintModelData = async (invoiceId) => {
    const resp = await apiMethod.getOrderPrintInfo(invoiceId);
    if (methods.showApiErrors(resp)) {
      printModel.orderPrintModel = resp.data.orderPrintModel;
      printModel.kitchenPrintModel = resp.data.kitchenPrintModel;
      printModel.printers = resp.data.printers;
      setPrintModel({ ...printModel });
      await setPrinterDevices(printModel.printers);
      return true;
    }
    else {
      return false;
    }
  }

  const setPrinterDevices = async (printers) => {
    let orderPrinter = await printers.find(x => x.printerUnitType === 1);
    let kitchenPrinter = await printers.find(x => x.printerUnitType === 2);
    printModel.orderPrintModel.printerName = orderPrinter.name;
    printModel.kitchenPrintModel.printerName = kitchenPrinter.name;
    setPrintModel({ ...printModel });
  }

  const printOrderReceipt = async () => {
    if (!validPrinters(1))
      return false;

    const apiRes = await apiMethod.orderBillPrint(localService.baseUrl, printModel.orderPrintModel);

    if (!methods.showApiErrors(apiRes))
      return false;
  };

  const printKitchenOrder = async () => {
    if (!validPrinters(2))
      return false;

    const apiRes = await apiMethod.kitchenOrderPrint(localService.baseUrl, printModel.kitchenPrintModel);

    if (!methods.showApiErrors(apiRes))
      return false;
  };

  const printInvoice = async (invoiceId, printType) => {
    var isOkInfo = await setPrintModelData(invoiceId);
    if (!isOkInfo)
      return false;

    if (printType === 1 || printType === 3)
      await printOrderReceipt();

    if (printType === 2 || printType === 3)
      await printKitchenOrder();
  };

  const paymentTypeChanged = (paymentType) => {
    paymentModel.paymentType = parseInt(paymentType);

    if (paymentModel.paymentType === 3 || paymentModel.paymentType === 5) {
      getPosData(filterObj.cashDeskId);
    }

    if (paymentModel.paymentType === 10) {
      sendToKitchen();
    }
    paymentModel.cashAmount = 0;
    paymentModel.posAmount = 0;
    paymentModel.amount = 0;
    paymentModel.tipAmount = 0;
    calcPaymentAmounts();
    setPaymentModel({ ...paymentModel });
  };

  const tipAmountChanged = (tipAmount) => {
    if (tipAmount === "" || tipAmount === null || tipAmount === undefined)
      tipAmount = "0";
    tipAmount = methods.allReplace(tipAmount, ",", "");
    paymentModel.tipAmount = parseInt(tipAmount);
    calcPaymentAmounts();
    setPaymentModel({ ...paymentModel });
  };

  const cashAmountChanged = (cash) => {
    if (cash === "" || cash === null || cash === undefined)
      cash = "0";
    cash = methods.allReplace(cash, ",", "");
    let paymentAmount = paymentModel.tipAmount + (totalNumbers.totalFinalPrice / 10);
    if (paymentAmount <= parseInt(cash))
      return false;

    paymentModel.cashAmount = parseInt(cash);
    calcPaymentAmounts();
    setPaymentModel({ ...paymentModel });
  };

  const calcPaymentAmounts = () => {
    let paymentAmount = paymentModel.tipAmount + (totalNumbers.totalFinalPrice / 10);
    if (paymentModel.paymentType === 1) {
      paymentModel.cashAmount = paymentAmount;
      paymentModel.amount = paymentAmount;
    }
    if (paymentModel.paymentType === 3) {
      paymentModel.posAmount = paymentAmount;
      paymentModel.amount = paymentAmount;
      paymentModel.cashAmount = 0;
    }
    if (paymentModel.paymentType === 4 || paymentModel.paymentType === 6) {
      paymentModel.amount = paymentAmount;
      paymentModel.cashAmount = 0;
      paymentModel.posAmount = 0;
    }
    if (paymentModel.paymentType === 5) {
      paymentModel.posAmount = paymentAmount - paymentModel.cashAmount;
      paymentModel.amount = paymentModel.posAmount;
    }
  };

  const validPayment = () => {
    var errors = [];
    if (order.id === 0)
      errors.push("برای پرداخت باید سفارش ابتدا ثبت بشود.");

    if (paymentModel.paymentType === 0)
      errors.push("نحوه پرداخت باید انتخاب شود.");

    // if (paymentModel.amount === 0)
    //   errors.push("برای پرداخت باید مبلغ پرداخت مقدار داشته باشد.");

    if ((paymentModel.paymentType === 3 || paymentModel.paymentType === 5) && paymentModel.amount < 3000)
      errors.push("مبلغ پرداختی پوز نمی تواند کمتر از 3000 تومن باشه.");

    if (errors.length > 0) {
      methods.showErrors(errors);
      return false;
    }
    return true;
  };

  const makePayment = async () => {
    if (!validPayment())
      return false;
    setpaymentWaiting(true);
    const payResp = await apiMethod.orderPayment({
      paymentType: paymentModel.paymentType,
      posDeviceId: paymentModel.posDeviceId,
      invoiceId: order.id,
      tipAmount: paymentModel.tipAmount * 10,
      amount: paymentModel.amount * 10,
      cashAmount: paymentModel.cashAmount * 10,
      cardNumber: ""
    });

    setpaymentWaiting(false);

    if (!methods.showApiErrors(payResp))
      return false;
    await printInvoice(order.id, 3);
    await sendToKitchen();
    await bindMenus();
    resetPaymentModel();
    setFilterObj({ ...filterObj });
    setPaymentModalShow(false);
  };

  const cancelPayment = async () => {
    const apiRes = await apiMethod.cancelPayment({
      posDeviceId: parseInt(paymentModel.posDeviceId),
      invoiceId: order.id
    });
    if (!methods.showApiErrors(apiRes))
      return false;
    setpaymentWaiting(false);
    methods.showSuccesses(["پرداخت با موفقیت لغو شد."]);
  };

  const movePagerPart = (isForward) => {
    if (isForward) {
      if (filterObj.parts < filterObj.part + 1) {
        return false;
      }
      callPager(filterObj.part + 1);
    } else {
      if (filterObj.part === 1) {
        return false;
      }
      callPager(filterObj.part - 1);
    }
  };

  const callPager = async (i) => {
    setLoading(true);
    filterObj.part = i;
    setFilterObj({ ...filterObj });
    await bindMenus();
    setLoading(false);
  };

  const makePagerItems = () => {
    let pages = [];
    for (let i = 1; i <= filterObj.parts; i++) {
      pages.push(
        <li key={i} className={filterObj.part === i ? 'page-item active mx-1' : 'page-item mx-1'}>
          <a className="page-link circular-pagination" onClick={() => { callPager(i) }}>
            {i}
          </a>
        </li>
      );
    }
    return pages;
  };

  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: -scrollRef.current.offsetWidth / 2,
        behavior: 'smooth',
      });
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: scrollRef.current.offsetWidth / 2,
        behavior: 'smooth',
      });
    }
  };

  const reorder = async (invoiceId) => {
    if (invoiceId < 1) {
      methods.showErrors(["حداقل یک آیتم برای سفارش دوباره باید انتخاب شود."]);
      return false;
    }
    setLoading(true);

    await getBulkOrderInfo(invoiceId);
    order.id = 0;
    order.invoiceNumber = "";
    order.orderNumber = "";
    order.createDate = "";
    setOrder({ ...order });
    await bindMenus();
    setShowMerchantPreviousOrdersModal(false);
    setLoading(false);
  };

  const changeItemDescription = (e, itemId) => {
    const updatedOrderItems = orderItems.map(item =>
      item.id === itemId ? { ...item, description: e.target.value } : item
    );
    setOrderItems(updatedOrderItems);
  };

  const saveItemDescription = async (item) => {
    const reqBody = {
      id: item.id,
      saleMenuId: item.saleMenuId,
      amount: item.amount,
      description: item.description,
      packingPrice: item.menuPackingPrice,
      invoiceId: item.invoiceId,
    };
    await apiMethod.createOrderItem(reqBody);
  };

  const moduleBinder = () => {
    return (
      <div className='bg-light px-1'>
        {loading && <Preloading></Preloading>}
        {
          <>
            {/* <Notification></Notification> */}
            <div className='orderHeader'>
              <div className='orderTitle'>
                <Link to={`/waiterpanel`} className='link back-link'>
                  <span><img src={back} className="" alt="return" /></span>
                </Link>
                ثبت سفارش
                <a href={`/sale/${branchId}/softwareGuide/#section11`} className="link rtlicon me-1" title="برای اطلاعات بیشتر کلیک کنید" target="_blank" rel="noopener noreferrer">
                  <i className="bi bi-question-circle"></i>
                </a>
              </div>
              <div className='row g-2 px-2'>
                <div className='col-12 col-md-4 col-lg-3'>
                  <select
                    id="ddlsalesunit"
                    className="form-select ch-bt"
                    aria-label="Default select example"
                    value={filterObj.unitId}
                    onChange={(e) => saleUnitchanged(e.target.value)}
                  >
                    <option value={0}>انتخاب بخش فروش </option>
                    {units.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>
                <div className='col-12 col-md-3 col-lg-2'>
                  <button onClick={() => { openCurrentOrderModal() }} type='button' className='btn custome-btn btn-outline-green w-100'>
                    سفارش های جاری <span className='badge bg-danger'>{currentOrders.length}</span>
                  </button>
                </div>
              </div>
            </div>
            <div className='orderBody'>
              <div className="d-flex align-items-center border-bottom">
                <i className="bi bi-chevron-right mx-1 scrollIcon" onClick={scrollRight}></i>
                <ul ref={scrollRef} className="nav nav-pills w-100 mb-1" id="pills-tab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${filterObj.categoryId === 0 ? 'activeOrderLink' : ''}`}
                      onClick={() => onCategoryClick(0)}>
                      همه دسته‌بندی‌ها
                    </button>
                  </li>
                  {menuCategories.map((category) => (
                    <li className="nav-item" role="presentation" key={category.id}>
                      <button
                        className={`nav-link ${filterObj.categoryId === category.id ? 'activeOrderLink' : ''}`}
                        onClick={() => onCategoryClick(category.id)}>
                        {category.title}
                      </button>
                    </li>
                  ))}
                </ul>
                <i className="bi bi-chevron-left mx-1 mb-1 scrollIcon" onClick={scrollLeft}></i>
              </div>
              <div className='row p-1'>
                <div className="col-lg-8 orderContent position-relative">
                  <div className="tab-content" id="pills-tabContent">
                    <div
                      className="tab-pane fade show active mb-5"
                      id="pills-home"
                      role="tabpanel"
                      aria-labelledby="pills-home-tab"
                      tabIndex="0"
                    >
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <div className="input-box col-lg-4">
                          <input
                            type="text"
                            className="form-control"
                            style={{ direction: "rtl", textAlign: "right" }}
                            value={filterObj.menuTitle}
                            onChange={(e) => {
                              findMenus(e.target.value);
                            }}
                          />
                          <i className="bi bi-search"></i>
                        </div>
                        <div>
                          <button
                            type="button"
                            className={`btn btn-sm rounded-circle p-0 ${
                              isCardView ? "active" : ""
                            }`}
                            onClick={() => setCardView(true)}
                          >
                            {isCardView ? (
                              <img src={CardViewActive} />
                            ) : (
                              <img src={CardView} alt="CardView" />
                            )}{" "}
                          </button>
                          <button
                            type="button"
                            className={`btn btn-sm rounded-circle p-0 ms-2 ${
                              !isCardView ? "active" : ""
                            }`}
                            onClick={() => setCardView(false)}
                          >
                            {!isCardView ? (
                              <img src={ImgViewActive} alt="imgView" />
                            ) : (
                              <img src={ImgView} alt="imgView" />
                            )}
                          </button>
                        </div>
                      </div>
                      <div
                        className={`row card-view-wrapper row-cols-1 ${
                          isCardView ? "row-cols-2" : "row-cols-md-4"
                        } g-1 pb-4`}
                      >
                        {saleMenus.map((menu) => (
                          <div className="col card-view-col" key={menu.id}>
                            {/* <div className={`card orderCard h-100 ${isCardView ? 'cardView' : 'imgView'}`}> */}
                            <div
                              className={`card orderCard h-100 ${
                                isCardView ? "cardView" : "imgView"
                              } ${cardDisabled ? "disabled" : ""}`}
                              onClick={() => {
                                !cardDisabled &&
                                  addOrderItem(
                                    0,
                                    menu.id,
                                    1,
                                    menu.packagingPrice
                                  );
                              }}
                            >
                              <div
                                className={`card-body-order ${
                                  isCardView && "card-items"
                                }`}
                              >
                                {!isCardView && (
                                  <div
                                    className="orderCardImg"
                                    style={{
                                      backgroundImage: `url(${methods.normalImage(
                                        menu.imgSrc,
                                        "menu"
                                      )})`,
                                    }}
                                  ></div>
                                )}
                                {!isCardView && (
                                  <span className="badge rounded-pill sidebar-badge foodBadge">
                                    غذای اصلی
                                  </span>
                                )}
                                <span className="badge rounded-pill itemNumberBadge">
                                  ۳۳۳ پرس
                                </span>
                                <p className="orderCardTitle">{menu.title}</p>
                                {/* {menu.discount ? <p className='discountbadge'>{menu.discount}% تخفیف</p> : <p ></p>} */}
                                <div
                                  style={{
                                    height: "24px",
                                    textAlign: "center",
                                  }}
                                >
                                  {menu.discount ? (
                                    <p className="discountbadge mx-auto">
                                      {menu.discount}% تخفیف
                                    </p>
                                  ) : (
                                    <p></p>
                                  )}
                                </div>
                                <p className="mb-1">
                                  {methods.addNumSeperator(menu.price / 10)}{" "}
                                  تومان
                                </p>
                                {/* <div className="orderCardFooter"
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <i
                                    className={`bi bi-plus-circle ${
                                      disabled ? "disabled" : ""
                                    }`}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      !disabled &&
                                        addOrderItem(
                                          0,
                                          menu.id,
                                          1,
                                          menu.packagingPrice
                                        );
                                    }}
                                  ></i>
                                  <span className="mx-2">
                                    {menu.orderItemCount}
                                  </span>
                                  <i
                                    className={`bi bi-dash-circle ${
                                      disabled ? "disabled" : ""
                                    }`}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      !disabled &&
                                        removeNumberOfItemFromOrder(
                                          0,
                                          menu.id,
                                          1,
                                          menu.packagingPrice
                                        );
                                    }}
                                  ></i>
                                </div> */}
                              </div>
                              <div className="hoverCount"></div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div>
                      {filterObj.parts > 1 && (
                        <div className="pagination justify-content-center mt-5">
                          <Paginations
                            total={filterObj.total}
                            size={filterObj.size}
                            onPageChange={callPager}
                          />
                        </div>
                      )}
                    </div>
                    <div className="pushData">
                      {callers.length > 0 && (
                        <button
                          type="button"
                          className="btn btn-lg btn-purple position-relative pushDatabtn"
                          onClick={() => {
                            setShowCallerIdModal(true);
                          }}
                        >
                          <i className="bi bi-telephone-inbound"></i>
                          {callers.length > 0 && (
                            <span className="pushDatabadge">
                              {callers.length}
                            </span>
                          )}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
                <div className='col-lg-4'>
                  <div className='d-md-flex justify-content-center  pb-1 border-bottom'>
                    <button
                      type="button"
                      className="btn custome-btn btn-outline-greenLight ms-3"
                      onClick={() => setShowCreateMerchantModal(true)}
                    ><i className="bi bi-person-plus ms-1"></i>ثبت مشتری جدید</button>
                    <button
                      onClick={() => { setPrintKitchenModalShow(true) }}
                      type="button"
                      className="btn custome-btn btn-outline-purple"
                    >ارسال اصلاحات به آشپزخانه</button>
                  </div>
                  <div className="accordion accordionOrder my-3" id="accordionExample">
                    <div className="accordion-item">
                      <div className="accordion-header d-flex justify-content-between align-content-center">
                        <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                          نام مشتری: {order.merchantName}
                        </button>
                      </div>
                      <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                        <div className="accordion-body border m-1 rounded">
                          <div className='d-flex flex-row-reverse'>
                            <button onClick={() => { resetOrder() }} className='btn custome-btn btn-link-danger mb-1' type='button'>
                              <i className="bi bi-trash3 ms-1"></i>
                              پاک‌کردن فرم</button>
                          </div>
                          <div className="row g-3">
                            <div className="col-md-6">
                              <label htmlFor="mercnaht-name" className="form-label">نام مشتری</label>
                              <input type="text" className="form-control" id="mercnaht-name" name="title"
                                value={order.merchantName || ""}
                                onChange={(e) => { changedMerchantName(e.target.value) }}
                              />
                            </div>
                            <div className="col-md-6">
                              <label htmlFor="merchant-mobile" className="form-label">شماره موبایل</label>
                              <input type="text" className="form-control" id="merchant-mobile" name="title"
                                value={order.merchantPhone || ""}
                                onChange={(e) => { changedMerchantMobile(e.target.value) }}
                              />
                            </div>
                            <div className="col-md-6">
                              <label htmlFor="merchant-code" className="form-label">کد اشتراک</label>
                              <input type="text" className="form-control" id="merchant-code" name="title"
                                value={order.merchantCode || ""}
                                onChange={(e) => { changedMerchantCode(e.target.value) }}
                              />
                            </div>
                            {filterObj.orderType === 1 && (
                              <div className="col-md-6">
                                <label htmlFor="ddltable" className="form-label">انتخاب میز</label>
                                <select
                                  id="ddltable"
                                  className="form-select"
                                  aria-label="Default select example"
                                  value={order.diningTableId || ""}
                                  onChange={(e) => { setOrder({ ...order, diningTableId: e.target.value }) }}
                                >
                                  <option value="">انتخاب میز</option>
                                  {diningTables.map((item) => (
                                    <option key={item.id} value={item.id}>
                                      {item.title}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            )}
                            {filterObj.orderType === 1 && (
                              <div className='col-md-6'>
                                <label htmlFor="ddlpager" className="form-label">انتخاب پیجر</label>
                                <select
                                  id="ddlpager"
                                  className="form-select"
                                  aria-label="Default select example"
                                  value={order.pagerDeviceId || ""}
                                  onChange={(e) => { setOrder({ ...order, pagerDeviceId: e.target.value }) }}
                                >
                                  <option value="">انتخاب پیجر</option>
                                  {pagers.map((item) => (
                                    <option key={item.id} value={item.id}>
                                      {item.title}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            )}
                            {filterObj.orderType === 2 && (
                              <div className='col-md-12'>
                                <label htmlFor="address" className="form-label">آدرس</label>
                                <textarea type="text" className="form-control mb-4" id="address" name="address" rows="2"
                                  value={order.destination || ""}
                                  onChange={(e) => { setOrder({ ...order, destination: e.target.value }) }}
                                ></textarea>
                              </div>
                            )}
                            {filterObj.orderType === 2 && (
                              <div className='col-12'>
                                <select
                                  id="ddshipment"
                                  className="form-select"
                                  aria-label="Default select example"
                                  value={order.shipmentId || ""}
                                  // onChange={(e) => { setOrder({ ...order, shipmentId: e.target.value }) }}
                                  onChange={(e) => { shipmentIdChanged(e) }}
                                >
                                  <option value={0}>هزینه ارسال</option>
                                  {shipments.map((item) => (
                                    <option key={item.id} value={item.id}>
                                      {item.areaTitle} - {methods.addNumSeperator(item.price)}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            )}
                            <div className='col-md-6'>
                              <div className="form-group align-items-center">
                                <label htmlFor="packingprice" className="form-label">هزینه بسته‌بندی (ریال)</label>
                                <input type="text" className="form-control" id="packingprice" name="title"
                                  // value={orderingSettings.finalPackingPrice}
                                  value={methods.addNumSeperator(orderingSettings.finalPackingPrice)}
                                  onChange={(e) => {
                                    orderingSettings.finalPackingPrice = methods.allReplace(e.target.value, ',', '');
                                    setOrderingSettings({ ...orderingSettings });
                                  }}
                                />
                              </div>
                            </div>
                            <div className='col-md-12'>
                              <div className="form-group align-items-center">
                                <label htmlFor="serveprice" className="form-label">هزینه سرویس (ریال)</label>
                                <input type="text" className="form-control" id="serveprice" name="title"
                                  // value={orderingSettings.finalPackingPrice}
                                  value={methods.addNumSeperator(order.servePrice)}
                                  onChange={(e) => {
                                    order.servePrice = methods.allReplace(e.target.value, ',', '');
                                    setOrder({ ...order });
                                  }}
                                />
                              </div>
                            </div>

                            <div className='col-md-6'>
                              <p className="seePreOrders pt-2 text-start" onClick={() => { showMerchantPreviousOrders(order.userId) }} >همون همیشگی</p>
                            </div>

                            <div className='col-md-6'>
                              <button type="button" className="btn btn-order w-100"
                                onClick={showMerchants}>
                                <i className="bi bi-person-check ms-1"></i>
                                {/* <img src={searchCustomer} alt='searchCustomer' className='me-1' /> */}
                                جستجوی مشتری
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='border rounded p-1'>
                    <table className="table table-md align-middle table-responsive text-center">
                      <thead className='align-middle'>
                        <tr>
                          <th scope="col vertical-center" width="20px">ردیف</th>
                          <th scope="col vertical-center">عنوان کالا</th>
                          <th scope="col vertical-center">تعداد</th>
                          <th scope="col vertical-center">قیمت(تومان)</th>
                          <th scope="col vertical-center">توضیحات</th>
                        </tr>
                      </thead>
                      <tbody className='align-middle'>
                        {orderItems.map((item, index) => (
                          <tr key={item.id}>
                            <th scope="row">{index + 1}</th>
                            <td>{item.productName}</td>
                            <td>
                              <div className='orderPriceCell'>
                                <i className="bi bi-plus-circle" onClick={() => { addOrderItem(item.id, item.saleMenuId, 1, item.menuPackingPrice) }}></i>
                                <span className='mx-1 my-1'>{item.amount}</span>
                                <i className="bi bi-dash-circle" onClick={() => { removeOrderItem(item.id, item.saleMenuId, 1, item.menuPackingPrice) }}></i>
                              </div>
                            </td>
                            <td>{methods.addNumSeperator((item.taxFreePrice * item.amount) / 10)}</td>
                            <td>
                              <input type='text' className='form-control'
                                value={item.description}
                                onChange={(e) => changeItemDescription(e, item.id)}
                                onBlur={() => saveItemDescription(item)}
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className='text-start mt-3 p-1'>
                    <p>جمع فروش:{methods.addNumSeperator(totalNumbers.totalFreeTaxPrice / 10)} تومان</p>
                    <p>جمع تخفیف:{methods.addNumSeperator(totalNumbers.totalDiscount / 10)} تومان</p>
                    {
                      totalNumbers.services.map((item) => (
                        <p key={item.id}>{item.productName}: {methods.addNumSeperator(item.taxFreePrice / 10)} تومان</p>
                      ))
                    }
                    <p>مالیات وعوارض :{methods.addNumSeperator(totalNumbers.totalTax / 10)} تومان</p>
                    <p>مبلغ قابل پرداخت:{methods.addNumSeperator(totalNumbers.totalFinalPrice / 10)} تومان</p>
                    <p>توضیحات سفارش:</p>
                    <textarea
                      value={order.orderDescription}
                      onChange={(e) => { setOrder({ ...order, orderDescription: e.target.value }) }}
                      type="text" className="form-control mb-4" id="orderDescription" name="orderDescription" />
                  </div>
                  <div className='d-flex flex-column flex-md-row '>
                    <button onClick={() => { removeOrderFromForm(order.id) }} type="button" className="btn btn-link-danger  m-2">حذف</button>
                    <button type="button" onClick={() => { saveOrder() }} className={`btn btn-order m-2 ${cardDisabled ? 'disabled' : ''}`} disabled={!(orderItems.length > 0)}
                    >ذخیره</button>
                    {/* <button type="button" onClick={async () => { await saveOrder(); sendToKitchen() }} className="btn btn-order m-2" disabled={!(orderItems.length > 0)}>آشپزخانه</button> */}
                    <button type="button" onClick={async () => { await saveOrder(); setPaymentModalShow(true) }} className={`btn btn-order m-2 m-2 ${cardDisabled ? 'disabled' : ''}`} disabled={!(orderItems.length > 0)}>پرداخت</button>
                    {order.id !== 0 ?
                      <div className="dropdown-center">
                        <button className={`btn btn-order m-2 ${cardDisabled ? 'disabled' : ''}`} type="button" data-bs-toggle="dropdown" aria-expanded="false">
                          <i className="bi bi-printer"></i>
                        </button>
                        <ul className="dropdown-menu p-0 mx-4">
                          <li className="dropdown-item btn btn-order btn-sm" onClick={async () => { await saveOrder(); printInvoice(order.id, 2) }}>
                            <i className="bi bi-printer ms-1"></i>
                            چاپ آشپزخانه
                          </li>
                          <li className="dropdown-item btn btn-order btn-sm" onClick={async () => { await saveOrder(); printInvoice(order.id, 1) }}>
                            <i className="bi bi-printer ms-1"></i>
                            چاپ صندوق
                          </li>
                        </ul>
                      </div>
                      :
                      <button type="button" className="btn btn-order m-2" disabled>
                        <i className="bi bi-printer"></i>
                      </button>
                    }
                  </div>
                </div>
              </div>
            </div>
          </>
        }
      </div >
    )
  };

  const merchantFilterCallPager = async (i) => {
    setLoading(true);
    merchantFilter.part = i;
    setMerchantFilter({ ...merchantFilter });
    await showMerchants();
    setLoading(false);
  };

  const merchantFilterMovePagerPart = (isForward) => {
    if (isForward) {
      if (merchantFilter.parts < merchantFilter.part + 1) {
        return false;
      }
      merchantFilterCallPager(merchantFilter.part + 1);
    } else {
      if (merchantFilter.part === 1) {
        return false;
      }
      merchantFilterCallPager(merchantFilter.part - 1);
    }
  };

  const merchantFilterMakePagerItems = () => {
    let pages = [];
    for (let i = 1; i <= merchantFilter.parts; i++) {
      pages.push(
        <li key={i} className={merchantFilter.part === i ? 'page-item active mx-1' : 'page-item mx-1'}>
          <a className="page-link circular-pagination" onClick={() => { merchantFilterCallPager(i) }}>
            {i}
          </a>
        </li>
      );
    }
    return pages;
  };

  let latestOrderDate = [];
  const showMerchantPreviousOrders = async (userId) => {
    if (!userId) {
      toast.error('ابتدا باید مشتری انتخاب شود', {
        position: "top-right",
        autoClose: 1000,
        theme: "colored",
        style: {
          backgroundColor: "#FBE7E7",
          color: "#D00707"
        },
        progressClassName: "progressBarColor",
      });
    } else {
      setLoading(true);
      merchantPreviousOrdersFilter.userId = userId;
      setMerchantPreviousOrdersFilter({ ...merchantPreviousOrdersFilter, userId: merchantPreviousOrdersFilter.userId });
      const resp = await apiMethod.getMerchantPreviousOrders(merchantPreviousOrdersFilter.branchId, merchantPreviousOrdersFilter.userId, merchantPreviousOrdersFilter.size, merchantFilter.part, merchantPreviousOrdersFilter.repCount);
      setLoading(false);
      if (methods.showApiErrors(resp)) {
        setMerchantPreviousOrders(resp.merchant);
        setMerchantPreviousOrdersInfo(resp.info);
        setMerchantPreviousOrdersData(resp.data);
        setMerchantPreviousOrdersRepetitives(resp.repetitives)
        latestOrderDate = resp.data[0];
      }

      setShowMerchantPreviousOrdersModal(true);
      setShowSearchMerchantModal(false);
    }

  };

  const closeModal = () => {
    resetMerchant();
    setShowCreateMerchantModal(false);
    setShowSearchMerchantModal(false);
  };

  const closePrintKitchenModal = () => {
    resetCorrectionModel();
    setPrintKitchenModalShow(false);
  };

  const createMerchantModal = () => {
    return (
      <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: showcreateMerchantModal ? 'block' : 'none' }}>
        <div className="modal-dialog  modal-md" role="document">
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title">ایجاد مشتری</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeModal}
              >
              </button>
            </div>
            <div className="modal-body">
              <div className="row g-3">
                <div className="col-md-12">
                  <label htmlFor="merchantType" className="form-label">نوع مشتری</label>
                  <select
                    id="merchantType"
                    className="form-select"
                    aria-label="Default select example"
                    value={merchant.merchantType}
                    onChange={(e) => {
                      setMerchant({ ...merchant, merchantType: parseInt(e.target.value) });
                    }}
                  >
                    <option value="">انتخاب کنید</option>
                    <option value={1}>حقیقی</option>
                    <option value={2}>حقوقی</option>
                  </select>
                </div>
                {merchant.merchantType === 1 && (
                  <>
                    <div className="col-md-12">
                      <label htmlFor="firstname" className="form-label required-label">نام</label>
                      <input
                        type="text"
                        className="form-control"
                        id="firstname"
                        value={merchant.firstName || ""}
                        onChange={(e) => { setMerchant({ ...merchant, firstName: e.target.value }) }}
                      />
                    </div>
                    <div className="col-md-12">
                      <label htmlFor="lastname" className="form-label required-label">نام‌خانوادگی</label>
                      <input
                        type="text"
                        className="form-control"
                        id="lastname"
                        value={merchant.lastName || ""}
                        onChange={(e) => { setMerchant({ ...merchant, lastName: e.target.value }) }}
                      />
                    </div>
                    <div className="col-md-12">
                      <label htmlFor="nationalNumber" className="form-label">شماره‌ملی</label>
                      <input
                        type="text"
                        className="form-control"
                        id="nationalNumber"
                        value={merchant.nationalNumber || ""}
                        onChange={(e) => { setMerchant({ ...merchant, nationalNumber: e.target.value }) }}
                      />
                    </div>
                    <div className="col-md-12">
                      <label htmlFor="mobile" className="form-label required-label">تلفن همراه</label>
                      <input
                        type="text"
                        className="form-control"
                        id="mobile"
                        value={methods.formatPhoneNumber(merchant.mobile) || ""}
                        onChange={(e) => { setMerchant({ ...merchant, mobile: e.target.value }) }}
                      />
                    </div>
                    <div className="col-md-12">
                      <label htmlFor="phone" className="form-label required-label">تلفن ثابت</label>
                      <input
                        type="text"
                        className="form-control"
                        id="phone"
                        value={merchant.phone}
                        onChange={(e) => { setMerchant({ ...merchant, phone: e.target.value }) }}
                      />
                    </div>
                    <div className="col-md-12">
                      <label className="checkbox-label">
                        <input
                          type="checkbox"
                          checked={merchant.creditable}
                          onChange={(e) => { setMerchant({ ...merchant, creditable: e.target.checked }) }}
                        />
                        <span className='me-1'>مجوز استفاده از اعتبار</span>
                      </label>
                    </div>
                    {userAddresses.map((item, index) => (
                      <div key={index} className="col-md-12">
                        <label htmlFor={`addresstitle${index}`} className="form-label">عنوان آدرس</label>
                        <input
                          type="text"
                          className="form-control"
                          id={`addresstitle${index}`}
                          value={item.title}
                          onChange={(e) => addressTitleChange(index, e.target.value)}
                        />
                        <label htmlFor={`address${index}`} className="form-label">آدرس</label>
                        <textarea
                          type="text"
                          className="form-control"
                          id={`address${index}`}
                          value={item.address}
                          onChange={(e) => addressTextChange(index, e.target.value)}
                        />
                      </div>
                    ))}
                    <div className="col-md-12 text-center">
                      <button
                        type="button"
                        className="btn custome-btn btn-link-green"
                        onClick={addAddressField}
                      >
                        اضافه کردن آدرس
                      </button>
                    </div>
                  </>
                )}
                {merchant.merchantType === 2 && (
                  <>
                    <div className="col-md-12">
                      <label htmlFor="firstName" className="form-label required-label">نام شرکت</label>
                      <input
                        type="text"
                        className="form-control"
                        id="firstName"
                        value={merchant.firstName || ""}
                        onChange={(e) => { setMerchant({ ...merchant, firstName: e.target.value }) }}
                      />
                    </div>
                    <div className="col-md-12">
                      <label htmlFor="companyName" className="form-label required-label">نام تجاری شرکت</label>
                      <input
                        type="text"
                        className="form-control"
                        id="companyName"
                        value={merchant.companyName || ""}
                        onChange={(e) => { setMerchant({ ...merchant, companyName: e.target.value }) }}
                      />
                    </div>
                    <div className="col-md-12">
                      <label htmlFor="economicCode" className="form-label">کد اقتصادی</label>
                      <input
                        type="text"
                        className="form-control"
                        id="economicCode"
                        value={merchant.economicCode || ""}
                        onChange={(e) => methods.validateNumberInput(e.target.value) && setMerchant({ ...merchant, economicCode: e.target.value })}

                      />
                    </div>
                    <div className="col-md-12">
                      <label htmlFor="registrationNumber" className="form-label">شماره ثبت</label>
                      <input
                        type="text"
                        className="form-control"
                        id="registrationNumber"
                        value={merchant.registrationNumber || ""}
                        onChange={(e) => methods.validateNumberInput(e.target.value) && setMerchant({ ...merchant, registrationNumber: e.target.value })}
                      />
                    </div>
                    <div className="col-md-12">
                      <label htmlFor="phone" className="form-label required-label">شماره موبایل</label>
                      <input
                        type="text"
                        className="form-control"
                        id="phone"
                        value={merchant.mobile}
                        onChange={(e) => { setMerchant({ ...merchant, mobile: e.target.value }) }}
                      />
                    </div>
                    <div className="col-md-12">
                      <label className="checkbox-label">
                        <input
                          type="checkbox"
                          checked={merchant.creditable}
                          onChange={(e) => { setMerchant({ ...merchant, creditable: e.target.checked }) }}
                        />
                        <span className='me-1'>مجوز استفاده از اعتبار</span>
                      </label>
                    </div>
                    {userAddresses.map((item, index) => (
                      <div key={index} className="col-md-12">
                        <label htmlFor={`addresstitle${index}`} className="form-label">عنوان آدرس</label>
                        <input
                          type="text"
                          className="form-control"
                          id={`addresstitle${index}`}
                          value={item.title}
                          onChange={(e) => addressTitleChange(index, e.target.value)}
                        />
                        <label htmlFor={`address${index}`} className="form-label">آدرس</label>
                        <textarea
                          type="text"
                          className="form-control"
                          id={`address${index}`}
                          value={item.address}
                          onChange={(e) => addressTextChange(index, e.target.value)}
                        />
                      </div>
                    ))}
                    <div className="col-md-12 text-center">
                      <button
                        type="button"
                        className="btn custome-btn btn-link-green"
                        onClick={addAddressField}
                      >
                        اضافه کردن آدرس
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn custome-btn btn-link-purple" onClick={closeModal}>
                انصراف
              </button>
              <button onClick={createMerchant} type="button" className="btn custome-btn btn-purple w-50">ثبت و ذخیره</button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const searchMerchantModal = () => {
    return (
      <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: showsearchMerchantModal ? 'block' : 'none' }}>
        <div className="modal-dialog  modal-xl" role="document" >
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title">مدیریت مشتری</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeModal}
              >
              </button>
            </div>
            <div className="modal-body">
              <div className='table-responsive saletable mt-0'>
                <table className="table table-striped table-md align-middle" >
                  <thead className=''>
                    <tr>
                      <th scope="col vertical-center" width="20px">ردیف</th>
                      <th scope="col vertical-center">نام و نام‌خانوادگی</th>
                      <th scope="col vertical-center">موبایل</th>
                      <th scope="col vertical-center">اشتراک</th>
                      <th scope="col vertical-center">آرشیو سفارشات</th>
                      <th scope="col vertical-center" width="50px">عملیات</th>
                    </tr>
                  </thead>
                  <tbody className=''>
                    {merchantList.map((item, index) => (
                      <tr key={item.id}>
                        <th scope="row">{((merchantFilter.part - 1) * merchantFilter.size) + index + 1}</th>
                        <td>{item.firstName}  {item.lastName}</td>
                        <td>{item.mobile}</td>
                        <td>{item.merchantCode}</td>
                        <td>
                          <button type="button" className="btn btn-sm btn-outline-purple"
                            // onClick={() => { setMerchantPreviousOrders(true) }}
                            onClick={() => showMerchantPreviousOrders(item.userId)}
                          >سفارش‌های قبلی
                          </button>
                        </td>
                        <td>
                          <button type="button" className="btn btn-sm btn-outline-purple"
                            onClick={() => selectMerchant(item, item.userAddresses, item.userId)} >
                            انتخاب مشتری
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {merchantFilter.parts > 1 &&
                  <nav aria-label="Page navigation example" className='mt-5'>
                    <ul className="pagination justify-content-center">
                      <li className="page-item mx-1">
                        <a className="page-link circular-pagination" onClick={() => { merchantFilterMovePagerPart(false) }}>
                          <i className="bi bi-chevron-compact-right"></i>
                        </a>
                      </li>
                      {merchantFilterMakePagerItems()}
                      <li className="page-item mx-1">
                        <a className="page-link circular-pagination" onClick={() => { merchantFilterMovePagerPart(true) }}>
                          <i className="bi bi-chevron-compact-left"></i>
                        </a>
                      </li>
                    </ul>
                  </nav>
                }
              </div>
            </div>
          </div >
        </div >
      </div >
    )
  };

  const currentOrderModal = () => {
    return (
      <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: currentOrderModalShow ? 'block' : 'none' }}>
        <div className="modal-dialog modal-xl" role="document" >
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title">سفارشات باز</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => { setCurrentOrderModalShow(false) }}
              >
              </button>
            </div>
            <div className="modal-body">
              {currentOrders.length === 0 && <p className='text-center fs-5 my-5'>هیچ آیتمی برای نمایش وجود ندارد.</p>}
              {currentOrders.map((item, index) => (
                <div className="accordion mb-3" id={'acc_' + index} key={item.id}>
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target={'#collap_' + index} aria-expanded="true" aria-controls={'collap_' + index}>
                        {orderTypes[item.orderType - 1].title} - {item.merchantName} - شماره {item.orderNumber} - موبایل {item.merchantPhone}
                      </button>
                    </h2>
                    <div id={'collap_' + index} className="accordion-collapse collapse show" data-bs-parent={'#acc_' + index}>
                      <div className="accordion-body">
                        <div className='card shadow mb-4'>
                          <div className='card-body'>
                            <div className='table-responsive'>
                              <table className='table table-bordered'>
                                <tbody>
                                  <tr>
                                    <td>نوع سفارش: {orderTypes[item.orderType - 1].title}</td>
                                    <td>بخش فروش: {item.saleUnitTitle}</td>
                                    <td>صندوق: {item.cashDeskTitle}</td>
                                  </tr>
                                  <tr>
                                    <td>شماره فاکتور: {item.invoiceNumber}</td>
                                    <td>شماره فیش: {item.orderNumber}</td>
                                    <td>تاریخ: {methods.toPersianDate(item.createDate)}</td>
                                  </tr>
                                  <tr>
                                    <td>نام مشتری: {item.merchantName}</td>
                                    <td>موبایل: {item.merchantPhone}</td>
                                    <td>اشتراک: {item.merchantCode}</td>
                                  </tr>
                                  <tr>
                                    <td colSpan={3}>آدرس: {item.destination}</td>
                                  </tr>
                                  <tr>
                                    <td>مالیات: {methods.addNumSeperator(item.totalTax / 10)}</td>
                                    <td>تخفیف: {methods.addNumSeperator(item.totalDiscount / 10)}</td>
                                    <td>مبلغ فاکتور: {methods.addNumSeperator(item.totalFinalPrice / 10)}</td>
                                  </tr>
                                  <tr>
                                    <td className='text-center bg-light' colSpan={3}>اقلام فاکتور</td>
                                  </tr>
                                  <tr>
                                    <td colSpan={3}>
                                      <table className='table text-center'>
                                        <thead>
                                          <tr>
                                            <th>کد</th>
                                            <th>عنوان</th>
                                            <th>مبلغ واحد</th>
                                            <th>تعداد</th>
                                            <th>مالیات</th>
                                            <th>تخفیف</th>
                                            <th>مجموع</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {item.invoiceItems.map((oItem, oIndex) => (
                                            oItem.invoiceItemType == 1 && (
                                              <tr key={`${oIndex}-${oItem.id}`}>
                                                <td>{oItem.productCode}</td>
                                                <td>{oItem.productName}</td>
                                                <td>{methods.addNumSeperator(oItem.taxFreePrice / 10)}</td>
                                                <td>{oItem.amount}</td>
                                                <td>{methods.addNumSeperator(oItem.tax / 10)}</td>
                                                <td>{methods.addNumSeperator(oItem.discount / 10)}</td>
                                                <td>{methods.addNumSeperator(oItem.finalPrice / 10)}</td>
                                              </tr>
                                            )
                                          ))}
                                        </tbody>
                                      </table>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div className='text-center mb-4'>
                              <button onClick={() => { removeOrderFromCurrentLis(item.id) }} type='button' className='btn btn-outline-danger me-2'>
                                حذف سفارش
                              </button>
                              <button onClick={() => { editOrder(item.id) }} type='button' className='btn btn-purple me-2'>
                                ویرایش سفارش
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    )
  };

  const resetPaymentModel = () => {
    paymentModel.paymentType = 0;
    paymentModel.posDeviceId = 0;
    paymentModel.invoiceId = 0;
    paymentModel.tipAmount = 0;
    paymentModel.amount = 0;
    paymentModel.cashAmount = 0;
    paymentModel.posAmount = 0;
    paymentModel.cardNumber = "";
  };

  const closePaymentModal = () => {
    resetPaymentModel();
    setPaymentModalShow(false);
  };

  const paymentModal = () => {
    return (
      <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: paymentModalShow ? 'block' : 'none' }}>
        <div className="modal-dialog modal-xl" role="document" >
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title">پرداخت سفارش</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closePaymentModal}
              >
              </button>
            </div>
            <div className="modal-body position-relative">
              {paymentWaiting && paymentModel.paymentType !== 1 && (
                <div className='payment-waining position-absolute'>
                  <div className='payment-messagebox text-center p-4'>
                    <h4>لطفا کار مشتری را در دستگاه کارتخوان بکشید</h4>
                    <p>پس از کشیدن کارت مبلغ نمایش داده می شود.</p>
                    <div className='mt-4'>
                      <button onClick={() => { cancelPayment() }} type='button' className='btn btn-outline-light btn-lg'>لغو پرداخت</button>
                    </div>
                  </div>
                </div>
              )}
              <div className='row mb-4'>
                <div className='col-md-3'>
                  <div className='form-group'>
                    <label className='mb-2'>نحوه پرداخت</label>
                    <select
                      value={paymentModel.paymentType}
                      onChange={(e) => { paymentTypeChanged(e.target.value) }}
                      className='form-select'>
                      <option value={0}>انتخاب کنید</option>
                      <option value={3}>کارتخوان</option>
                      <option value={1}>نقدی</option>
                      <option value={5}>نقدی و کارتخوان</option>
                      <option value={4}>کارت به کارت</option>
                      <option value={6}>اعتباری</option>
                      <option value={7}>مهمان</option>
                      <option value={8}>تست غذا</option>
                      <option value={9}>جلب رضایت مشتری</option>
                      <option value={10}>پرداخت در محل</option>
                    </select>
                  </div>
                </div>
                {(paymentModel.paymentType === 3 || paymentModel.paymentType === 5) && (<>
                  <div className='col-md-3'>
                    <div className='mb-3'>
                      <label className='mb-2'>دستگاه کارتخوان</label>
                      <select
                        value={paymentModel.posDeviceId}
                        onChange={(e) => { setPaymentModel({ ...paymentModel, posDeviceId: e.target.value }) }}
                        className='form-select'>
                        <option value={0}>انتخاب دستگاه</option>
                        {posDevices.map((item, index) => (
                          <option
                            value={item.posDeviceId}
                            key={item.id}
                          >{item.title}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </>
                )}

                <div className='col-md-3'>
                  <div className='mb-3'>
                    <label className='mb-2'>انعام (تومن)</label>
                    <input
                      value={methods.addNumSeperator(paymentModel.tipAmount)}
                      onChange={(e) => { tipAmountChanged(e.target.value) }}
                      type='text' className='form-control' placeholder='0' />
                  </div>
                </div>
                {(paymentModel.paymentType === 1 || paymentModel.paymentType === 5) && (<>
                  <div className='col-md-3'>
                    <div className='mb-3'>
                      <label className='mb-2'>نقدی (تومن)</label>
                      <input
                        value={methods.addNumSeperator(paymentModel.cashAmount)}
                        onChange={(e) => { cashAmountChanged(e.target.value) }}
                        type='text' className='form-control' placeholder='0' />
                    </div>
                  </div>
                </>
                )}
                {(paymentModel.paymentType === 5 || paymentModel.paymentType === 3) && (<>
                  <div className='col-md-3'>
                    <div className='form-group'>
                      <label className='mb-2'>پوز (تومن)</label>
                      <input
                        value={methods.addNumSeperator(paymentModel.posAmount)}
                        //onChange={(e) => { setPaymentModel({ ...paymentModel, posAmount: e.target.value }) }}
                        type='text' className='form-control' placeholder='0' disabled />
                    </div>
                  </div>
                </>
                )}
              </div>
              <div className='mb-4 text-center'>
                {/* <button
                  onClick={() => { printInvoice(order.id, 3) }}
                  type='button' className='btn custome-btn btn-outline-purple w-25 ms-3'>چاپ</button> */}
                <button
                  onClick={() => { makePayment() }}
                  type='button' className='btn custome-btn btn-purple w-50'>پرداخت</button>
              </div>
              <br />
              <hr />
              <br />
              <div className='row mb-4'>
                <div className='col-md-6'>
                  <div className='fish-print-view'>
                    <div id="order-print" className='print-table order-print'>
                      <div className='row mb-2'>
                        <div className='col-6'>
                          شماره فاکتور: {order.invoiceNumber}
                        </div>
                        <div className='col-6 text-end'>
                          {methods.toPersianDate(order.createDate)}
                        </div>
                      </div>
                      <table className='table table-bordered border-dark border-2'>
                        <tbody>
                          <tr>
                            <td colSpan={3}>مشتری: {order.merchantName}</td>
                            <td colSpan={1}>اشتراک: {order.merchantCode}</td>
                          </tr>
                          <tr>
                            <td colSpan={4}>آدرس: {order.destination}</td>
                          </tr>
                          <tr>
                            <td width='25%'>کالا</td>
                            <td width='25%'>فی</td>
                            <td width='25%'>تعداد</td>
                            <td width='25%'>قیمت</td>
                          </tr>
                          {orderItems.filter(item => item.invoiceItemType === 1).map((item, index) => (
                            <tr key={item.id}>
                              <td>{item.productName}</td>
                              <td className='text-center'>{methods.addNumSeperator(item.taxFreePrice)}</td>
                              <td className='text-center'>{item.amount}</td>
                              <td className='text-center'>{methods.addNumSeperator(item.taxFreePrice * item.amount)}</td>
                            </tr>
                          ))}
                          <tr>
                            <td colSpan={2}>جمع فروش:</td>
                            <td colSpan={2}>{methods.addNumSeperator(totalNumbers.totalFreeTaxPrice)}</td>
                          </tr>
                          <tr>
                            <td colSpan={2}>مالیات و عوارض:</td>
                            <td colSpan={2}>{methods.addNumSeperator(totalNumbers.totalTax)}</td>
                          </tr>
                          <tr>
                            <td colSpan={2}>جمع تخفیف:</td>
                            <td colSpan={2}>{methods.addNumSeperator(totalNumbers.totalDiscount)}</td>
                          </tr>
                          {orderItems.filter(x => x.invoiceItemType === 2).map((item, index) => (
                            <tr key={item.id}>
                              <td colSpan={2}>{item.productName}</td>
                              <td colSpan={2}>{methods.addNumSeperator(item.finalPrice)}</td>
                            </tr>
                          ))}
                          <tr>
                            <td colSpan={2}>قابل پرداخت:</td>
                            <td className='bg-secondary text-white fs-6 fw-bold' colSpan={2}>{methods.addNumSeperator(totalNumbers.totalFinalPrice)}</td>
                          </tr>
                          <tr>
                            <td className='text-center' colSpan={4}>{invoicePirntInfo.footer1}</td>
                          </tr>
                          <tr>
                            <td className='text-center' colSpan={4}>{invoicePirntInfo.footer2}</td>
                          </tr>
                          <tr>
                            <td className='text-center' colSpan={4}>{invoicePirntInfo.footer3}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className='fish-print-view'>
                    <div id="kitchen-order-print" className='print-table order-print '>
                      <div className='row mb-2'>
                        <div className='col-6'>
                          شماره فاکتور: {order.invoiceNumber}
                        </div>
                        <div className='col-6 text-end'>
                          {methods.toPersianDate(order.createDate)}
                        </div>
                      </div>
                      <div className="table-responsive">
                        <table className='table table-bordered border-dark border-2' >
                          <tbody>
                            <tr>
                              <td colSpan={4}>
                                <h6 className='text-center mt-2'>آشپزخانه</h6>
                              </td>
                            </tr>
                            <tr>
                              <td width='65px'>ردیف</td>
                              <td width='150px'>کالا</td>
                              <td width='60px'>تعداد</td>
                              <td>توضیحات</td>
                            </tr>
                            {orderItems.filter(item => item.invoiceItemType === 1).map((item, index) => (
                              <tr key={item.id}>
                                <td className='text-center'>{index + 1}</td>
                                <td>{item.productName}</td>
                                <td className='text-center'>{item.amount}</td>
                                <td>{item.description}</td>
                              </tr>
                            ))}
                            <tr>
                              <td colSpan={12}>
                                <b>توضیحات سفارش:</b> {order.orderDescription}
                              </td>
                            </tr>
                            <tr></tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    )
  };

  const printKitchenModal = () => {
    return (
      <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: printKitchenModalShow ? 'block' : 'none' }}>
        <div className="modal-dialog modal-lg" role="document" >
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title">ارسال اصلاحات به آشپزخانه</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => { closePrintKitchenModal() }}
              >
              </button>
            </div>
            <div className="modal-body">
              <div className='row mb-4'>
                <div className='col-md-4'>
                  <div className='mb-3'>
                    <label className='mb-2'>شماره فاکتور</label>
                    <input
                      value={correctionModel.invoiceNumber}
                      onChange={(e) => { setCorrectionModel({ ...correctionModel, invoiceNumber: e.target.value }) }}
                      type='text' className='form-control' placeholder='شماره' />
                  </div>
                </div>
                <div className='col-md-12'>
                  <div className='mb-3'>
                    <label className='mb-2'>توضیحات</label>
                    <textarea
                      value={correctionModel.description}
                      onChange={(e) => { setCorrectionModel({ ...correctionModel, description: e.target.value }) }}
                      type='text' className='form-control' placeholder='متن' rows={3}></textarea>
                  </div>
                </div>
              </div>
              <div className='mb-4 text-center'>
                <button onClick={() => { addCorrectionToList() }} type='button' className='btn btn-purple w-50 mx-2'
                  disabled={!(correctionModel.invoiceNumber && correctionModel.description)}
                >
                  افزودن به لیست
                </button>
              </div>
              <div className='table-responsive mb-4'>
                <table className='table table-bordered'>
                  <thead>
                    <tr className='text-center'>
                      <td className='bg-light'>شماره فاکتور</td>
                      <td className='bg-light'>توضیحات</td>
                      <td className='bg-light' width="70px"></td>
                    </tr>
                  </thead>
                  <tbody>
                    {correctionModel.items.map((item, index) => (
                      <tr key={`${item.id}-${index}`}>
                        <td>{item.invoiceNumber}</td>
                        <td>{item.description}</td>
                        <td>
                          <button
                            onClick={() => { removeFormCorrectionLis(index) }}
                            type="button" className="btn btn-link-danger  me-2">حذف</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className='text-center mb-4'>
                <button onClick={() => { printKitchenCorrection() }}
                  type='button' className='btn btn-outline-purple w-50 mx-2' disabled={!(correctionModel.items.length > 0)}>
                  چاپ
                </button>
              </div>
              <div className='table-responsive text-center'>
                <table className="table table-bordered" >
                  <thead className=''>
                    <tr>
                      <th scope='col' className='bg-light' colSpan={2}>
                        اصلاحات آشپزخانه
                      </th>
                    </tr>
                    <tr>
                      <th scope="col">شماره فاکتور</th>
                      <th scope="col">توضیحات</th>
                    </tr>
                  </thead>
                  <tbody className='align-middle'>
                    {correctionModel.items.map((item, index) => (
                      <tr key={`${item.id}-${index}`}>
                        <td>{item.invoiceNumber}</td>
                        <td>{item.description}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  };

  const merchantPreviousOrdersModal = () => {
    return (
      <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: showMerchantPreviousOrdersModal ? 'block' : 'none' }}>
        <div className="modal-dialog modal-lg" role="document" >
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title">مدیریت مشتری</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => { setShowMerchantPreviousOrdersModal(false) }}
              >
              </button>
            </div>
            <div className="modal-body">
              <h6 className='text-start'> سفارشات قبلی {merchantPreviousOrders.firstname} {' '} {merchantPreviousOrders.lastname}</h6>
              <div className="border mt-3 rounded" >
                <div className='border rounded'>
                  <div className='text-center bg-light fs-5 p-2 rounded-top'>اطلاعات خرید مشتری</div>
                  <div>
                    <div className='d-flex justify-content-between text-start p-3'>
                      <div>
                        <h5>پرتکرار ها</h5>
                        {merchantPreviousOrdersRepetitives.map((item, index) => (
                          <div key={`${item.id}-${index}`}>
                            <p>{item.productName} <span className='badge text-bg-secondary'>{item.countOfProducts}</span></p>
                          </div>
                        ))}
                      </div>
                      <div className=''>
                        <h5>اطلاعات خرید</h5>
                        <p> مبلغ کل خریدها: {methods.addNumSeperator(merchantPreviousOrdersInfo.totalPurchaseAmount)}</p>
                        <p> تعداد کل: {merchantPreviousOrdersInfo.invoiceCount}</p>
                        <p> بیشترین مبلغ: {methods.addNumSeperator(merchantPreviousOrdersInfo.maxInvoiceAmount)}</p>
                        <p> کمترین مبلغ: {methods.addNumSeperator(merchantPreviousOrdersInfo.minInvoiceAmount)}</p>
                      </div>
                      <div>
                        <h5>آخرین سفارش</h5>
                        <p>تاریخ:{methods.toPersianDate(latestOrderDate.createDate, 'jYYYY/jMM/jDD')}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="accordion my-3" id="accordionExampleTwo">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                      سه خرید آخر
                    </button>
                  </h2>
                  <div id="collapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordionExampleTwo">
                    <div className="accordion-body">
                      {merchantPreviousOrdersData.map((order, index) => (
                        <div className="accordion accordionOrder mb-3" id={'acc_' + index} key={`${index}-${order.id}`}>
                          <div className="accordion-item">
                            <h2 className="accordion-header">
                              <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target={'#collap_' + index} aria-expanded="true" aria-controls={'collap_' + index}>
                                <span className="badge sidebar-badge rounded-pill ms-2">{orderTypes.find(orderType => orderType.id === order.orderType)?.title}</span>
                                <span className='mx-2'><strong> شماره فاکتور:</strong> {order.invoiceNumber}</span> -  <span className='mx-2'><strong>تاریخ سفارش: </strong>{methods.toPersianDate(order.createDate, 'jYYYY/jMM/jDD')}</span>
                              </button>
                            </h2>
                            <div id={'collap_' + index} className="accordion-collapse collapse show" data-bs-parent={'#acc_' + index}>
                              <div className="accordion-body">
                                {order.invoiceItems && order.invoiceItems.length > 0 && (
                                  <table className="table table-striped table-sm text-center my-2">
                                    <caption className='text-end my-3'> مبلغ کل: {methods.addNumSeperator(order.totalFinalPrice)}</caption>
                                    <thead className='align-middle'>
                                      <tr>
                                        <th scope="col vertical-center" width="20px">ردیف</th>
                                        <th scope="col vertical-center">عنوان</th>
                                        <th scope="col vertical-center">تعداد</th>
                                        <th scope="col vertical-center">توضیحات</th>
                                        <th scope="col vertical-center">مبلغ کل</th>
                                      </tr>
                                    </thead>
                                    <tbody className='align-middle'>
                                      {order.invoiceItems.filter(item => item.invoiceItemType === 1).slice(0, 3).map((item, itemIndex) => (
                                        <tr key={`${index}-${itemIndex}-${item.id}`}>
                                          <th key={itemIndex} scope="row">{itemIndex + 1}</th>
                                          <td>{item.productName}</td>
                                          <td>{item.amount}</td>
                                          <td>{item.description}</td>
                                          <td>{methods.addNumSeperator(item.finalPrice)}</td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                )}
                                <p>توضیحات:{order.orderDescription}</p>
                                <div className='text-end'>
                                  <button className='btn btn-outline-purple my-2 w-25'
                                    onClick={() => { reorder(order.id) }}
                                  >سفارش مجدد</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  };

  const showSnappOrderToast = () => {
    return (
      <div className="toast-container position-fixed p-3 end-0" style={{ bottom: '60px' }}>
        <div className={`toast ${showSnappToast ? 'show' : 'hide'}`} role="alert" aria-live="assertive" aria-atomic="true">
          <div className="toast-header snapp-toast-header">
            <span className="mx-auto fw-bold fs-6">سفارش جدید اسنپ ثبت شده است !</span>
            <i className="bi bi-x-lg fs-5" data-bs-dismiss="toast" aria-label="Close" onClick={() => setShowSnappToast(false)}></i>
          </div>
          <div className="toast-body snapp-toast-body d-flex justify-content-evenly align-items-center"
            onClick={() => { setShowSnappCallerIdModal(true); setShowSnappToast(false); }}
          >
            <img src={pushDataImg} alt='food' className='pushDataimg' />
            <span className='fw-bold fs-6'>برای دیدن جزئیات کلیک کنید.</span>
            {snappOrders.length > 0 && (
              <span className="badge bg-white fs-6 snapp-toast-badge">
                {snappOrders.length}
              </span>
            )}
          </div>
        </div>
      </div>
    )
  };

  return (
    <>
      {moduleBinder()}
      {showcreateMerchantModal && createMerchantModal()}
      {showsearchMerchantModal && searchMerchantModal()}
      {currentOrderModalShow && currentOrderModal()}
      {paymentModalShow && paymentModal()}
      {printKitchenModalShow && printKitchenModal()}
      {showMerchantPreviousOrdersModal && merchantPreviousOrdersModal()}
      {showCallerIdModal && (
        <OrderPushData
          open={showCallerIdModal}
          closeCallerIdModal={() => setShowCallerIdModal(false)}
          createNewMerchant={(mappedItem) => {
            setMerchant(mappedItem);
            setShowCreateMerchantModal(true);
          }}
          selectMerchant={selectMerchant}
          callers={callers}
          resetCallers={resetCallers}
          removeCaller={removeCaller}
        />
      )}
      {showSnappCallerModal && (
        <SnappPushData
          open={showSnappCallerModal}
          closeSnappCallerModal={() => setShowSnappCallerIdModal(false)}
          createNewMerchant={(mappedItem) => {
            setMerchant(mappedItem);
            setShowCreateMerchantModal(true);
          }}
          selectMerchant={selectMerchant}
          snappOrders={snappOrders}
          resetSnappCallers={resetSnappCallers}
          cashDeskId={cashDeskId}
        />
      )}
      {showSnappToast && showSnappOrderToast()}
    </>
  );
}

export default WaiterOrdering;